<template>
    <p-table
      :items="items"
      :fields="computedFields"
      :enableRowSelection="false"
      :per-page="25">
        
      <template v-slot:cell(glCode)="{ value, item }">
        <p-advanced-select
          data-type="chartOfAccounts"
          v-model="item.chartOfAccountsId"
          :filter="filterChartOfAccounts"
          :addDisabledText="false"
          noSelectionMessage="Unassigned"
          style="max-height: 34px; width: 100%;" />
      </template>

      <template v-slot:cell(fulfillmentLocation)="{ item }">
        <div class="d-flex justify-content-center align-items-center" style="height: 38px;">
          <b-form-radio
            v-model="item.isSaleFulfillmentLocation"
            :value="true"
            @change="onSaleFulfillmentLocationChange(item)"
          />
        </div>
      </template>
    </p-table>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
      fields: {
        type: Array,
        required: true
      },
      filterChartOfAccounts: {
        type: Function,
        required: true
      },
      isStorePickup: {
        type: Boolean,
        default: false
      },
      selectedLocationId: {
        type: Number,
        default: null
      }
    },
    computed: {
      computedFields() {
        const baseFields = [...this.fields];
        if (this.isStorePickup) {
          baseFields.push({
            key: 'fulfillmentLocation',
            label: 'Fulfillment Location',
            thClass: 'text-center',
            tdClass: 'text-center'
          });
        }
        return baseFields;
      }
    },
    methods: {
      onSaleFulfillmentLocationChange(changedItem) {
        // Clear all other locations
        this.items.forEach(item => {
          if (item.locationId !== changedItem.locationId) {
            item.isSaleFulfillmentLocation = false;
          }
        });
        // Emit the changed location ID
        this.$emit('fulfillment-location-changed', changedItem.locationId);
      }
    }
  };
</script>